import { useMemo } from "react";

import { CodeEditor } from "components/elements";
import { Subsection } from "components/layout";
import { TiVoLaunchAttributes } from "hooks/tivoApps";

import { toJsonString } from "../../utils";
import { TEXTS } from "../constants";
import styles from "./LaunchAttrsSection.scss";
import { SubsectionWithFallback } from "./SubsectionWithFallback";

export type LaunchAttrsIntentTabProps = {
  attributes: TiVoLaunchAttributes;
};

export function LaunchAttrsIntentTab({
  attributes,
}: LaunchAttrsIntentTabProps) {
  const attributesWithCriteria = useMemo(
    () => toJsonString(attributes.attributesWithCriteria || undefined),
    [attributes.attributesWithCriteria]
  );

  const intent = useMemo(
    () => toJsonString(attributes.intent),
    [attributes.intent]
  );

  return (
    <div className={styles.subsection}>
      <Subsection header={TEXTS.VARIANT.INTENT_SUBS_HEADER}>
        <CodeEditor enableMouseWheel height="250px" value={intent} />
      </Subsection>
      <SubsectionWithFallback
        header={TEXTS.VARIANT.ATTRS_WITH_CRITERIA_SUBS_HEADER}
        value={attributesWithCriteria}
      >
        {(value) => (
          <CodeEditor enableMouseWheel height="250px" value={value} />
        )}
      </SubsectionWithFallback>
    </div>
  );
}
